import * as React from "react";
function SvgCameraSwitch(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.015 1.334a.5.5 0 01-.406.58l-2.367.416A11 11 0 0112 23a.5.5 0 110-1 10 10 0 004.774-18.786l1.186 2.02a.5.5 0 11-.862.506l-1.966-3.349a.5.5 0 01.343-.766l3.96-.696a.5.5 0 01.58.405zM5.565 4.346A10 10 0 0112 2a.5.5 0 000-1 11 11 0 00-5.243 20.67l-2.366.416a.5.5 0 00.173.985l3.947-.694a.5.5 0 00.361-.761l-1.97-3.356a.5.5 0 10-.862.506l1.186 2.021A10.001 10.001 0 015.565 4.346zM13.882 7a1.5 1.5 0 011.34.829l.086.171H17.5A1.5 1.5 0 0119 9.5v6a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 016 15.5v-6A1.5 1.5 0 017.5 8h2.19l.086-.17A1.5 1.5 0 0111.117 7h2.764zm-3.15 3.732a2.5 2.5 0 113.536 3.536 2.5 2.5 0 01-3.536-3.536zM12.5 11a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCameraSwitch);
export default ForwardRef;
